"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotNilAndEmpty = void 0;
const ramda_1 = require("ramda");
const isNilOrEmpty_1 = require("./isNilOrEmpty");
exports.isNotNilAndEmpty = (0, ramda_1.compose)(ramda_1.not, isNilOrEmpty_1.isNilOrEmpty);
